import { Button, Grid } from "@mui/material";
import { isNil } from "lodash";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { BarLoader } from "react-spinners";
import { PatchRomDto, useMutatePatchRom } from "./query/GeneratorSeedQuery";

const SeedDetailsScreen = () => {

    let { id } = useParams<{ id: string }>();

    //Query that give detail of the seed
    let [file, setFile] = useState<File | null>(null);
    let patchRom = useMutatePatchRom();

    const onSubmit = async () => {

        if (isNil(file) || isNil(id))
            return;

        let param: PatchRomDto = {
            rom: file,
            seedId: id
        };
        await patchRom.mutateAsync(param);
    }
    return <Grid>

        <input type="file" accept=".z64,.wad" id="rom" onChange={(e) => { setFile(e.target.files?.[0] ?? null) }} />
        <Button onClick={onSubmit} disabled={patchRom.isLoading}>Randomize me this and be gentle step-Bot</Button>
        {patchRom.isLoading && <BarLoader />}
    </Grid>
}

export default SeedDetailsScreen